var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "table-responsive" }, [
      _c(
        "table",
        { staticClass: "table table-bordered table-happy nomargin" },
        [
          _vm._m(0),
          _c(
            "tbody",
            _vm._l(_vm.listPaymentRequest, function(paymentRequest) {
              return _c("tr", { key: paymentRequest.id }, [
                _c("td", { staticClass: "text-right" }, [
                  _vm._v(_vm._s(paymentRequest.id))
                ]),
                _c("td", [
                  _vm._v(
                    _vm._s(
                      _vm._f("formatDate")(
                        paymentRequest.createdDate,
                        "DD-MM-YYYY HH:mm:ss"
                      )
                    )
                  )
                ]),
                _c("td", { staticClass: "text-right" }, [
                  _vm._v(
                    _vm._s(_vm.transformNumb(paymentRequest.totalOrder, "0,0"))
                  )
                ]),
                _c("td", { staticClass: "text-right" }, [
                  _vm._v(_vm._s(paymentRequest.shippingMethodDetail.name))
                ]),
                _c("td", { staticClass: "text-right" }, [
                  _vm._v(_vm._s(paymentRequest.note))
                ]),
                _c(
                  "td",
                  {
                    staticClass: "text-center",
                    on: {
                      click: function($event) {
                        return _vm.viewDetail(paymentRequest)
                      }
                    }
                  },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "lb-status",
                        style: {
                          "background-color": paymentRequest.statusDetail.color
                        }
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(paymentRequest.statusDetail.name) +
                            "\n                        "
                        )
                      ]
                    )
                  ]
                )
              ])
            }),
            0
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "w150 text-right" }, [_vm._v("Mã yêu cầu")]),
        _c("th", { staticClass: "w200" }, [_vm._v("Ngày yêu cầu")]),
        _c("th", { staticClass: "w200 text-right" }, [_vm._v("Tổng đơn")]),
        _c("th", { staticClass: "text-right" }, [
          _vm._v("Hình thức vận chuyển")
        ]),
        _c("th", { staticClass: "text-right" }, [_vm._v("Ghi chú HPO")]),
        _c("th", { staticClass: "w200 text-center" }, [_vm._v("Trạng thái")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }